export default __webpack_public_path__ + "bef8470d307bb2cd05b40bc7a149a07a.png";